import React, { useEffect, useCallback } from 'react'
import { ReactSVG } from 'react-svg'
import styled, { css } from 'styled-components/macro';


const SVGSelector = ({ className, image, svg, onSelect, areaSetup, sizing = 'contain' }) => {
    let areaElems = null;
    
    const handleAreaClick = useCallback((event) => {
        if (onSelect) onSelect(event.target.parentElement.id);
    }, [onSelect])
    
    
    const beforeSetup = (svgElem) => {
        if (sizing === 'fill') {
            svgElem.setAttribute('preserveAspectRatio', 'xMidYMid slice');
        }
    }
    
    const setupSVG = (error, svgElem) => {
        if (error) {
            console.error(error);
            return;
        }
        
        areaElems = [...svgElem.querySelectorAll('#areas > g')]; // convert to array
        
        areaElems.forEach((elem) => {
            elem.addEventListener('click', handleAreaClick);
            elem.classList.add('area');
            if (areaSetup) areaSetup(elem);
        });
    }
    
    useEffect(() => {
        return () => {
            if (areaElems) {
                areaElems.forEach((elem) => {
                    elem.removeEventListener('click', handleAreaClick);
                });
            }
        };
    }, [areaElems, handleAreaClick]);
    
    return (
        <Container className={className} $sizing={sizing}>
            <Inner>
                <Image src={image} alt=""/>
                
                {svg && (
                    <SVGContainer src={svg} beforeInjection={beforeSetup} afterInjection={setupSVG}/>
                )}
            </Inner>
        </Container>
    )
}


export default SVGSelector;

const Image = styled.img`
    position: relative;
    width: 100%;
    height: auto;
    z-index: 1;
`;

const Inner = styled.div`
    position: relative;
`;

const SVGContainer = styled(ReactSVG)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    
    > div {
        width: 100%;
        height: 100%;
    }
    
    svg {
        display: block;
        width: 100%;
        height: auto;
    }
    
    .area_outline,
    .area-outline {
        fill: transparent;
        cursor: pointer;
    }
`;

const Container = styled.div`
    width: 100%;

    ${props => props.$sizing === 'fill' && css`
        height: 100%;

        ${Inner} {
            height: 100%;
        }
        
        ${Image} {
            height: 100%;
            object-fit: cover;
        }
        
        ${SVGContainer} {
            svg {
                height: 100%;
            }
        }
    `}
`;
